import React, { useId } from "react";
import PropTypes from "prop-types";
import { Box, Typography, TextField, MenuItem } from "@mui/material";
export default function LiquidationKeyFilter({
  liquidationKeys,
  liquidationKey,
  onChange,
  loading,
  label = "Llave de liquidación",
  allLabel = "Todas las llaves de liquidación",
  emptyHelper = "No se informaron llaves de liquidación en los pasos.",
}) {
  const liquidationLabelId = useId();
  return (
    <Box
      sx={{
        mb: 1.5,
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "145px minmax(0, 720px)" },
        alignItems: "center",
        gap: { xs: 0.75, sm: 1.5 },
      }}
    >
      <Typography
        id={liquidationLabelId}
        sx={{ fontSize: 13, fontWeight: 700, color: "text.primary" }}
      >
        {label}
      </Typography>
      <TextField
        select
        fullWidth
        value={liquidationKey}
        onChange={(event) => onChange(event.target.value)}
        disabled={loading || !liquidationKeys.length}
        helperText={loading ? "Consultando llaves…" : liquidationKeys.length ? null : emptyHelper}
        SelectProps={{
          displayEmpty: true,
          inputProps: { "aria-labelledby": liquidationLabelId },
          MenuProps: {
            PaperProps: {
              sx: {
                maxHeight: 320,
                "& .MuiMenuItem-root": {
                  whiteSpace: "normal",
                  overflowWrap: "anywhere",
                  fontSize: 15,
                  lineHeight: 1.5,
                  minHeight: 48,
                  py: 1.5,
                  px: 2,
                },
              },
            },
          },
        }}
        sx={{
          minWidth: 0,
          "& .MuiOutlinedInput-root": {
            minHeight: 44,
            height: "auto",
            borderRadius: 2,
            bgcolor: "background.paper",
          },
          "& .MuiSelect-select": {
            minHeight: "24px !important",
            height: "auto !important",
            py: "10px !important",
            pl: "12px !important",
            pr: "40px !important",
            fontSize: "14px !important",
            lineHeight: "1.5 !important",
            fontWeight: 500,
            color: "text.primary",
            whiteSpace: "normal !important",
            overflowWrap: "anywhere",
            display: "flex",
            alignItems: "center",
          },
          "& .MuiSelect-icon": { fontSize: 22, right: 10 },
          "& .MuiFormHelperText-root": { mx: 0, mt: 0.5, fontSize: 12, lineHeight: 1.5 },
        }}
      >
        <MenuItem value="">{allLabel}</MenuItem>
        {liquidationKeys.map((key) => (
          <MenuItem key={key} value={key}>
            {key}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
}
LiquidationKeyFilter.propTypes = {
  liquidationKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  liquidationKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  label: PropTypes.string,
  allLabel: PropTypes.string,
  emptyHelper: PropTypes.string,
};
